/**
 ************* GENERAL APIs ***************
 */

export const API_GET_PUBLIC_FILE = (fileUuid) => `/public/file/${fileUuid}`;
export const API_GET_PRIVATE_FILE = (fileUUID) => `/file/sec/${fileUUID}`;

/**
 * *********** TEAM APIs ************
 */

export const API_CREATE_TEAM = 'team';
export const API_GET_TEAM = (teamID) => `team/${teamID}`;
export const API_UPDATE_TEAM = (teamID) => `team/${teamID}`;
export const API_DELETE_TEAM = (teamID) => `team/${teamID}`;
export const API_GET_TEAM_USERS = (teamID) => `team/${teamID}/users`;
export const API_GET_USER_TEAM_MEMBERSHIP = (teamID) =>
  `team/${teamID}/membership`;
export const API_FETCH_TEAM_USER = (teamID, userID) =>
  `team/${teamID}/user/${userID}`;
export const API_TEAM_ASSIGN_USERS = (teamID) => `team/${teamID}/assign-users`;
export const API_TEAM_UNASSIGN_USERS = (teamID) =>
  `team/${teamID}/unassign-users`;
export const API_DOWNLOAD_TEAM_ASSESSMENT_DATA_ACCESS_CHECK = (teamID, appID) =>
  `team/${teamID}/app/${appID}/export/access-check`;
export const API_DOWNLOAD_TEAM_ASSESSMENT_DATA = (teamID, appId) =>
  `team/${teamID}/app/${appId}/export`;
export const API_TEAM_APP_ROOT = (teamID, appID) =>
  `team/${teamID}/app/${appID}`;
export const API_FETCH_ASSESSMENT_COUNTS = (teamID) => `team/${teamID}/counts`;

export const API_GET_INBOX_ASSESSMENTS = () => '/assessments';
export const API_GET_INBOX_ASSESSMENT_VARIABLES = () => '/assessment/variables';
